var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 16,
    viewBox: "0 0 23 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_91_3611)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4883 15.1148C7.92085 15.1148 4.50893 12.8983 1.34403 8.52319C1.29008 8.44873 1.2602 8.35956 1.25839 8.26763C1.25658 8.1757 1.28292 8.08542 1.33389 8.00889C1.50642 7.74931 5.63052 1.64757 11.5769 1.50742C15.2202 1.41135 18.6996 3.60296 21.9259 7.99148C21.9804 8.06556 22.011 8.15451 22.0135 8.24642C22.016 8.33834 21.9904 8.42883 21.94 8.50578C21.7673 8.76978 17.6419 14.9726 11.6908 15.1124C11.6234 15.1139 11.5558 15.1148 11.4883 15.1148ZM2.26619 8.25502C5.24909 12.2815 8.4173 14.286 11.6657 14.2102C16.4877 14.0994 20.1693 9.42179 21.0058 8.2667C18.0222 4.30456 14.8513 2.34234 11.6025 2.40955C6.78406 2.5206 3.10595 7.11448 2.26619 8.25502Z",
    fill: "#807CE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6362 12.019C10.9026 12.019 10.1856 11.8015 9.57562 11.3939C8.96568 10.9864 8.4903 10.4071 8.20957 9.72938C7.92885 9.05166 7.8554 8.30591 7.99851 7.58645C8.14163 6.86698 8.49487 6.20611 9.01358 5.6874C9.53228 5.1687 10.1932 4.81545 10.9126 4.67234C11.6321 4.52923 12.3778 4.60268 13.0556 4.8834C13.7333 5.16412 14.3125 5.63951 14.7201 6.24945C15.1276 6.85938 15.3452 7.57647 15.3452 8.31003C15.344 9.29336 14.9529 10.2361 14.2576 10.9314C13.5623 11.6267 12.6195 12.0179 11.6362 12.019ZM11.6362 5.50364C11.0811 5.50364 10.5386 5.66823 10.0771 5.9766C9.61554 6.28497 9.25584 6.72327 9.04343 7.23607C8.83102 7.74887 8.77545 8.31314 8.88373 8.85753C8.99202 9.40192 9.2593 9.90197 9.65178 10.2944C10.0443 10.6869 10.5443 10.9542 11.0887 11.0625C11.6331 11.1708 12.1974 11.1152 12.7102 10.9028C13.223 10.6904 13.6613 10.3307 13.9696 9.86918C14.278 9.40767 14.4426 8.86508 14.4426 8.31003C14.4418 7.56598 14.1458 6.85263 13.6197 6.32651C13.0936 5.80039 12.3803 5.50445 11.6362 5.50364Z",
    fill: "#807CE0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_91_3611"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.6614,
    height: 15.3435,
    fill: "white",
    transform: "translate(0.805664 0.637939)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.163973375e97b0055d57313823421750.svg";
export { ForwardRef as ReactComponent };